import React from 'react';
import HeroContent from './components/HeroContent';
import Footer from './components/Footer';

const App: React.FC = () => {
  const showButtons = true;
  const openSlider = (section: string) => {
    console.log(`Opening slider for: ${section}`);
  };
  const scrollToGallery = () => {
    console.log('Scrolling to gallery');
  };
  const openVideoModal = () => {
    console.log('Opening video modal');
  };

  return (
    <div className=''>
    <div className="min-h-screen bg-teal-800 flex items-center justify-center">
      <HeroContent
        showButtons={showButtons}
        openSlider={openSlider}
        scrollToGallery={scrollToGallery}
        openVideoModal={openVideoModal}
      />
      
    </div>
    <div>
    <Footer />
    </div>
    </div>
  );
};

export default App;